import * as React from "react";
import {translate} from "react-i18next";
import {Header} from "../../components/Header";
import TextBody from "../../components/TextBody";
import BottomBar from "../../components/BottomBar";
import TopNav from "../../components/TopNav";
import {Container,Row,Col} from "reactstrap";
import StatusOverview from "../../components/StatusBar";
import vodafoneLogo from "../../media/icons/vf-logo.png";
import {SpacerRow} from "../../components/SpacerRow";
import {BrowserView,MobileView,isMobile} from "react-device-detect";
import InfoBlocks from "../../components/InfoBlocks";
import SubPageTopBar from "../../components/SubPageTopBar";

class Stage14Footer extends React.Component {

    constructor(props){
        super(props);
    }

    /**
     * render
     * @returns {*}
     */
    render() {

        const footerHeadline = <div>
            <Header
                textResource={"footer_title"}
            />
        </div>

        /**
         * open external vodafone-URL
         */
        const showVodafoneConditions = () => {
            // console.log( "FNX: showVodafoneConditions" );
            window.open("https://www.vodafone.de/agb.html");
        };

        /**
         * open external vodafone-URL
         */
        const showVodafoneImprint = () => {
            // console.log( "FNX: showVodafoneImprint" );
            window.open("https://www.vodafone.de/impressum.html");
        };

        /**
         * open external vodafone-URL
         */
        const showVodafonePrivacy = () => {
            // console.log( "FNX: showVodafonePrivacy" );
            window.open("https://www.vodafone.de/unternehmen/verantwortung/datenschutz-online.html");
        };

        return <Container>

            <MobileView>
                <SubPageTopBar
                        progress={0}
                        onClickClose={this.props.onClickClose}
                />
                <Col xs={2} style={{paddingTop:"20vh"}}></Col>
                {footerHeadline}
                <Col xs={'12'} className={"footer"}>
                    <BottomBar
                        showFooterButtons={true}
                        showFullWidth={true}
                        mainButtonOnClick={() => {
                            this.props.validationCallback(0);
                        }}
                        footerButtonConditionsTextResource={"footer_button_conditions"}
                        footerButtonConditionsOnClick={showVodafoneConditions}
                        footerButtonImprintTextResource={"footer_button_imprint"}
                        footerButtonImprintOnClick={showVodafoneImprint}
                        footerButtonPrivacyTextResource={"footer_button_privacy"}
                        footerButtonPrivacyOnClick={showVodafonePrivacy}
                    />
                </Col>
            </MobileView>

            <BrowserView>
                <SubPageTopBar
                    progress={0}
                    onClickClose={this.props.onClickClose}
                />
                <Col xs={2} style={{paddingTop:"20vh"}}></Col>
                    <Col xs={'12'} className={"footer"}>
                    {footerHeadline}
                    <BottomBar
                        showFooterButtons={true}
                        showFullWidth={true}
                        mainButtonOnClick={() => {
                            this.props.validationCallback(0);
                        }}
                        footerButtonConditionsTextResource={"footer_button_conditions"}
                        footerButtonConditionsOnClick={showVodafoneConditions}
                        footerButtonImprintTextResource={"footer_button_imprint"}
                        footerButtonImprintOnClick={showVodafoneImprint}
                        footerButtonPrivacyTextResource={"footer_button_privacy"}
                        footerButtonPrivacyOnClick={showVodafonePrivacy}
                    />
                </Col>
            </BrowserView>

        </Container>
    }
}

export default translate("translations")(Stage14Footer);